import apiClient from './api.service';

export interface AndroidWidgetConfig {
  storeId: number | null;
  searchIds: number[];
  showCentreBadge: boolean;
  showNotifBadge: boolean;
  showRecentNotifs: boolean;
}

export interface AndroidWidgetSummary {
  storeId: number | null;
  storeName: string;
  updatedAt: string;
  searches: Array<{ id: number; name: string; icon?: string; count: number; missing?: boolean }>;
  ordersToday: number;
  ordersYesterday: number;
  ordersDelta: number;
  todayDate: string;
  unreadMessages: number;
  unreadNotes: number;
  badges: { notifications: number; centre: number; notes: number };
  recentNotifications: Array<{ id: string; title: string; url: string }>;
  showCentreBadge: boolean;
  showNotifBadge: boolean;
  showRecentNotifs: boolean;
}

export interface AndroidWidgetSearchOption {
  id: number;
  name: string;
  icon?: string;
  group_name?: string | null;
}

const androidWidgetService = {
  async getConfig(): Promise<AndroidWidgetConfig> {
    const response = await apiClient.get('/me/android-widget/config');
    return response.data.data;
  },

  async saveConfig(config: AndroidWidgetConfig): Promise<AndroidWidgetConfig> {
    const response = await apiClient.put('/me/android-widget/config', config);
    return response.data.data;
  },

  async getSummary(): Promise<AndroidWidgetSummary> {
    const response = await apiClient.get('/me/android-widget/summary');
    return response.data.data;
  }
};

export default androidWidgetService;
